/**
 * Interface primary - funkce execute lze spustit z formulare pres Enter
 * @generateInstanceClass
 * @includeToDoc
 */
export interface IPrimary {
    isActive: boolean;
    isPrimary: boolean;
    visible: boolean;
    execute(): void;
}

export class IPrimary {
    private static _properties = ["isActive", "isPrimary", "visible"];
    private static _methods = ["execute"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._properties.some((value) => !Reflect.has(instance, value)) &&
            !this._methods.some(value => typeof instance[value] !== "function");
    }
}
